"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warnSnack = exports.errorSnack = void 0;
var _auth = require("../utils/auth");
var _notifications = require("../constants/notifications");
const errorSnack = text => ({
  ID: (0, _auth.randomString)(16),
  text,
  category: _notifications.CATEGORIES.ERROR,
  target: _notifications.TARGETS.EXTERNAL
});
exports.errorSnack = errorSnack;
const warnSnack = text => ({
  ID: (0, _auth.randomString)(16),
  text,
  category: _notifications.CATEGORIES.WARNING,
  target: _notifications.TARGETS.EXTERNAL
});
exports.warnSnack = warnSnack;